import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/SEO/SEO';
import HeaderComponent from '../components/Header';
import HeroLearningDetail from '../components/Hero/HeroLearningDetail';
import CardDeck from '../components/CardDeck/CardDeck';
import PillarEmbed from '../components/PillarEmbed';
import SocialProof from '../components/SocialProof';
import FooterComponent from '../components/Footer';
import ChiliPiper from '../components/SEO/ChiliPiper';

import { generateAlertCards, replaceH1s } from '../utils/richTextUtils';

import useTableOfContents from '../components/TableOfContents/utils/useTableOfContents';

const usePostFormatter = data => {
  if (!data || data === `undefined`) return null;
  const post = data?.post || '';
  const formattedPost = generateAlertCards(replaceH1s(post));
  return formattedPost;
};

const LearningDetail = ({ data, location }) => {
  const { t } = useTranslation();
  const contentRef = useRef();
  const post = data.datoCmsLearningPost;
  const relatedPosts = post.relatedPosts;
  const formattedPost = usePostFormatter(post);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (contentRef.current) {
      setTableData(useTableOfContents(contentRef.current));
    }
  }, []);

  return (
    <Layout>
      <HeaderComponent theme="Transparent - Dark" />
      <HeroLearningDetail component={post} />
      <PillarEmbed
        component={{
          richTextRef: contentRef,
          richText: formattedPost,
          tableData,
          showTableOfContents: true,
          showSubscriptionCard: true,
          showSlackCommunityCard: false,
        }}
        showParallaxGrid
        theme="green"
      />
      {relatedPosts.length > 0 && (
        <CardDeck
          component={{
            showParallaxGrid: true,
            backgroundColor: 'Midnight/25',
            heading: t('Want to keep reading?'),
            card: post?.relatedPosts?.map(item => ({
              heading: item?.internalName || item?.metaTags?.title || '',
              subhead: item?.metaTags?.description || '',
              callToAction: {
                url: `/learning/${item.slug}`,
                label: t('View Article'),
              },
            })),
          }}
        />
      )}
      <SocialProof component={data?.socialProof} />
      <FooterComponent />
      <ChiliPiper pathname={location?.pathname} />
    </Layout>
  );
};

export default LearningDetail;

export const Head = ({ data, location }) => {
  const post = data.datoCmsLearningPost;

  return (
    <SEO
      title={post?.metaTags?.title}
      description={post?.metaTags?.description}
      indexable={post?.indexable}
      imgUrl={post?.metaTags?.image?.url}
      pathname={location?.pathname}
    />
  );
};

export const LearningDetailQuery = graphql`
  query LearningDetailQuery($id: String!, $language: String!) {
    datoCmsLearningPost(id: { eq: $id }) {
      ...learningDetailQuery
    }
    socialProof: datoCmsSocialProofComponent(
      id: { eq: "DatoCmsSocialProofComponent-U3lxqivnTy-mVbCvH4pnpQ" }
    ) {
      ...datoCmsSocialProofComponent
    }
    locales: allLocale(
      filter: { ns: { in: ["index"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
